import { Component, HostListener, OnInit } from '@angular/core';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { UserSessionHandlerService } from '../../../core/user-session-handler/user-session-handler.service';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnInit {

  isLoading: boolean;

  @HostListener('window:keydown', ['$event'])
  onKeyDown(): void {
    this.userSessionHandler.startUserSession();
  }

  @HostListener('window:mousedown', ['$event'])
  onMouseDown(): void {
    this.userSessionHandler.startUserSession();
  }

  constructor(
    private router: Router,
    private userSessionHandler: UserSessionHandlerService) {

    // Spinner for lazyload modules
    router.events.forEach((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.isLoading = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.isLoading = false;
      }
    });
  }

  ngOnInit(): void {
    this.userSessionHandler.startUserSession();
  }

}
